import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { APIResult } from '../APIResult';
import { buildURL, logAPIErrorToNewrelic } from '../utils';

export const createWishList = async (): Promise<APIResult<WishListItem>> => {
    const url = buildURL(`${API.WISH_LISTS}`);
    const request: RequestInit = {
        method: METHOD.POST,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            name: 'My Wish List',
        }),
        credentials: 'include',
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem>();

    if (!res) {
        logAPIErrorToNewrelic(`createWishList`, `No Response.`, {
            request: request,
            url: url,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        result.success = true;
        result.data = await res.json();
    } else {
        logAPIErrorToNewrelic(`createWishList`, `Response Not OK`, {
            ...res,
            request: request,
            url: url,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
            response: res,
        });
    }

    return result;
};
